module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b5c0d259d78d3d6b7c74e52ccb376a03.png";